import { SvgIconComponent } from '@mui/icons-material';
import { Box } from '@mui/material';

interface TimelineProps {
  icon: SvgIconComponent;
  color: string;
  background: string;
  isCurrentUser: boolean;
}

export const Timeline = ({ isCurrentUser, icon: Icon, color, background }: TimelineProps) => (
  <Box data-history-timeline order={isCurrentUser ? 2 : 1} position="relative">
    <Box
      className="timeline"
      sx={{
        ':after': {
          content: '""',
          transform: 'translateX(-50%)',
          left: '50%',
          width: '1px',
          height: (theme) => `calc(100% + ${theme.spacing(3)})`,
          backgroundColor: (theme) => theme.palette.divider,
          position: 'absolute',
        },
      }}
    >
      <Icon
        sx={{
          borderRadius: '50%',
          width: 20,
          height: 20,
          position: 'relative',
          zIndex: 1,
          color,
          background,
          padding: (theme) => theme.spacing(0.5),
          mt: -0.3,
        }}
      />
    </Box>
  </Box>
);
